import React from "react";
import { renderTabMessage } from "../../utils/renderTabMessage";
import Dropdown from "app/components/shared/app/Dropdown";
import MerGraphWrapper from "../MerGraphWrapper";
import MerGraphDetails from "../MerGraphDetails";

const MerMobile = ({

    activeTab,
    setActiveTab,
    tabStates,

    merGoal,
    formattedGraphData,

    selectedMetric,
    setSelectedMetric,
    metricItems,

    predictionState,

    ...props

}) => {

    const activeState = undefined;

    const renderTab = (tabId, tabLabel, mer) => {
        const active = tabId === activeTab;
        return (
            <div
                className={`tab ${tabId} ${activeTab == tabId ? 'active' : ''}`}
                key={tabId}
                onClick={() => setActiveTab(tabId)}
            >
                <div className="label">

                    <div className={`mer-value ${parseFloat(mer) > merGoal ? 'status-good' : 'status-bad'}`}>
                        <span>{parseFloat(mer).toFixed(1)}</span>
                    </div>

                    <div className="msg">
                        <span>{tabLabel}</span>
                    </div>

                    <div className="arrow"></div>

                </div>

                {active && (

                    <div className="chart">

                        <Dropdown
                            selectedItem={metricItems.find(mi => mi.value === selectedMetric).label}
                            setSelection={setSelectedMetric}
                            items={metricItems}
                        />

                        { formattedGraphData && <MerGraphWrapper
                            formattedGraphData={formattedGraphData}
                            selectedMetric={selectedMetric}
                            dailyGoal={merGoal}
                            predictionState={predictionState}
                        /> }

                        <MerGraphDetails
                            activeTab={activeTab}
                            activeState={activeState}
                            selectedMetric={selectedMetric}
                        />

                    </div>

                )}

            </div>
        )
    }

    return (
        <div className="mer-page mobile page-layout">

            <div className="tabs">

                <div className="tab tab-message">
                    {/* <span> */}
                    {renderTabMessage(activeTab, tabStates[activeTab].data?.mer, merGoal)}
                    {/* </span> */}
                </div>

                {Object.entries(tabStates).map(([tabId, tabState]) => {
                    return renderTab(tabId, tabState.label, tabState.data?.mer);
                })}

            </div>

        </div>
    )
}

export default MerMobile;